import {IConsultationDuration} from "../../shared/models/static-data.model";
import {
    I8MinuteRuleChartItem,
    IBodyPart,
    ICaseStatus,
    ICommunicationModeType, IConcussionFileType,
    IEmploymentStatus,
    IGender,
    IInjuryType,
    ILanguage,
    IMedicalHistoryOption, IMedicalRecordDocumentType,
    IMusculoskeletalHistoryOption,
    IPhoneType,
    IProgressReportStat,
    IReferralType,
    IRelationship,
    ISocialMediaPlatform,
    ISurgicalHistoryOption
} from "../../shared/models/common.model";

export const GET_CONSULTATION_DURATION_LIST = 'GET_CONSULTATION_DURATION_LIST';
export const SET_CONSULTATION_DURATION_LIST = 'SET_CONSULTATION_DURATION_LIST';

export const GET_GENDER_LIST = 'GET_GENDER_LIST';
export const SET_GENDER_LIST = 'SET_GENDER_LIST';

export const GET_CONCUSSION_FILE_TYPES = 'GET_CONCUSSION_FILE_TYPES';
export const SET_CONCUSSION_FILE_TYPES = 'SET_CONCUSSION_FILE_TYPES';

export const GET_EMPLOYMENT_STATUS_LIST = 'GET_EMPLOYMENT_STATUS_LIST';
export const SET_EMPLOYMENT_STATUS_LIST = 'SET_EMPLOYMENT_STATUS_LIST';

export const GET_LANGUAGE_LIST = 'GET_LANGUAGE_LIST';
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';

export const GET_RELATIONSHIP_LIST = 'GET_RELATIONSHIP_LIST';
export const SET_RELATIONSHIP_LIST = 'SET_RELATIONSHIP_LIST';

export const GET_PHONE_TYPE_LIST = 'GET_PHONE_TYPE_LIST';
export const SET_PHONE_TYPE_LIST = 'SET_PHONE_TYPE_LIST';

export const GET_MEDICAL_HISTORY_OPTIONS_LIST = 'GET_MEDICAL_HISTORY_OPTIONS_LIST';
export const SET_MEDICAL_HISTORY_OPTIONS_LIST = 'SET_MEDICAL_HISTORY_OPTIONS_LIST';

export const GET_SURGICAL_HISTORY_OPTIONS_LIST = 'GET_SURGICAL_HISTORY_OPTIONS_LIST';
export const SET_SURGICAL_HISTORY_OPTIONS_LIST = 'SET_SURGICAL_HISTORY_OPTIONS_LIST';

export const GET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST = 'GET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST';
export const SET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST = 'SET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST';

export const GET_COMMUNICATION_MODE_TYPE_LIST = 'GET_COMMUNICATION_MODE_TYPE_LIST';
export const SET_COMMUNICATION_MODE_TYPE_LIST = 'SET_COMMUNICATION_MODE_TYPE_LIST';

export const GET_REFERRAL_TYPE_LIST = 'GET_REFERRAL_TYPE_LIST';
export const SET_REFERRAL_TYPE_LIST = 'SET_REFERRAL_TYPE_LIST';

export const GET_SOCIAL_MEDIA_PLATFORM_LIST = 'GET_SOCIAL_MEDIA_PLATFORM_LIST';
export const SET_SOCIAL_MEDIA_PLATFORM_LIST = 'SET_SOCIAL_MEDIA_PLATFORM_LIST';

export const GET_BODY_PART_LIST = 'GET_BODY_PART_LIST';
export const SET_BODY_PART_LIST = 'SET_BODY_PART_LIST';

export const GET_INJURY_TYPE_LIST = 'GET_INJURY_TYPE_LIST';
export const SET_INJURY_TYPE_LIST = 'SET_INJURY_TYPE_LIST';

export const GET_CASE_STATUS_LIST = 'GET_CASE_STATUS_LIST';
export const SET_CASE_STATUS_LIST = 'SET_CASE_STATUS_LIST';

export const GET_PROGRESS_REPORT_STATS_LIST = 'GET_PROGRESS_REPORT_STATS_LIST';
export const SET_PROGRESS_REPORT_STATS_LIST = 'SET_PROGRESS_REPORT_STATS_LIST';

export const GET_8_MINUTE_RULE_CHART = 'GET_8_MINUTE_RULE_CHART';
export const SET_8_MINUTE_RULE_CHART = 'SET_8_MINUTE_RULE_CHART';

export const GET_MEDICAL_RECORD_DOCUMENT_TYPES = 'GET_MEDICAL_RECORD_DOCUMENT_TYPES';
export const SET_MEDICAL_RECORD_DOCUMENT_TYPES = 'SET_MEDICAL_RECORD_DOCUMENT_TYPES';


export const GET_APPOINTMENT_STATUS_LIST = 'GET_APPOINTMENT_STATUS_LIST';
export const SET_APPOINTMENT_STATUS_LIST = 'SET_APPOINTMENT_STATUS_LIST';

export const GET_PAYMENT_MODES = 'GET_PAYMENT_MODES';
export const SET_PAYMENT_MODES = 'SET_PAYMENT_MODES';

export const GET_ACCESSIBLE_ACCOUNTS = 'GET_ACCESSIBLE_ACCOUNTS';
export const SET_ACCESSIBLE_ACCOUNTS = 'SET_ACCESSIBLE_ACCOUNTS';
export const GET_DOCUMENT_FILE_TYPES = 'GET_DOCUMENT_FILE_TYPES';
export const SET_DOCUMENT_FILE_TYPES = 'SET_DOCUMENT_FILE_TYPES';
export const GET_FACILITY_LIST = 'GET_FACILITY_LIST';
export const SET_FACILITY_LIST = 'SET_FACILITY_LIST';
export const GET_DOCUMENT_LIST = 'GET_DOCUMENT_LIST';
export const SET_DOCUMENT_LIST = 'SET_DOCUMENT_LIST';



export const GET_PHYSICAL_ACTIVITY_FREQUENCY = 'GET_PHYSICAL_ACTIVITY_FREQUENCY';
export const SET_PHYSICAL_ACTIVITY_FREQUENCY = 'SET_PHYSICAL_ACTIVITY_FREQUENCY';

export const GET_PHYSICAL_ACTIVITY_INTENSITY = 'GET_PHYSICAL_ACTIVITY_INTENSITY';
export const SET_PHYSICAL_ACTIVITY_INTENSITY = 'SET_PHYSICAL_ACTIVITY_INTENSITY';

export const GET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT = 'GET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT';
export const SET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT = 'SET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT';

export const GET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY = 'GET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY';
export const SET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY = 'SET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY';

export const GET_PHYSICAL_ACTIVITY_TYPES = 'GET_PHYSICAL_ACTIVITY_TYPES';
export const SET_PHYSICAL_ACTIVITY_TYPES = 'SET_PHYSICAL_ACTIVITY_TYPES';

export const GET_WEIGHT_UNITS = 'GET_WEIGHT_UNITS';
export const SET_WEIGHT_UNITS = 'SET_WEIGHT_UNITS';

export const GET_HEIGHT_UNITS = 'GET_HEIGHT_UNITS';
export const SET_HEIGHT_UNITS = 'SET_HEIGHT_UNITS';

export const getWeightUnits = () => {
    return { type: GET_WEIGHT_UNITS };
};

export const setWeightUnits = (weightUnits: any[]) => {
    return {
        type: SET_WEIGHT_UNITS,
        payload: { weightUnits }
    };
};

export const getHeightUnits = () => {
    return { type: GET_HEIGHT_UNITS };
};

export const setHeightUnits = (heightUnits: any[]) => {
    return {
        type: SET_HEIGHT_UNITS,
        payload: { heightUnits }
    };
};


// Action Creators
export const getPhysicalActivityFrequency = () => {
    return { type: GET_PHYSICAL_ACTIVITY_FREQUENCY };
};

export const setPhysicalActivityFrequency = (physicalActivityFrequencyList: any[]) => {
    return {
        type: SET_PHYSICAL_ACTIVITY_FREQUENCY,
        payload: { physicalActivityFrequencyList }
    };
};

export const getPhysicalActivityIntensity = () => {
    return { type: GET_PHYSICAL_ACTIVITY_INTENSITY };
};

export const setPhysicalActivityIntensity = (physicalActivityIntensityList: any[]) => {
    return {
        type: SET_PHYSICAL_ACTIVITY_INTENSITY,
        payload: { physicalActivityIntensityList }
    };
};

export const getPhysicalActivityFrequencyForHeartRateImpact = () => {
    return { type: GET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT };
};

export const setPhysicalActivityFrequencyForHeartRateImpact = (physicalActivityFrequencyForHeartRateImpactList: any[]) => {
    return {
        type: SET_PHYSICAL_ACTIVITY_FREQUENCY_FOR_HEART_RATE_IMPACT,
        payload: { physicalActivityFrequencyForHeartRateImpactList }
    };
};

export const getPhysicalActivityExerciseCapacity = () => {
    return { type: GET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY };
};

export const setPhysicalActivityExerciseCapacity = (physicalActivityExerciseCapacityList: any[]) => {
    return {
        type: SET_PHYSICAL_ACTIVITY_EXERCISE_CAPACITY,
        payload: { physicalActivityExerciseCapacityList }
    };
};

export const getPhysicalActivityTypes = () => {
    return { type: GET_PHYSICAL_ACTIVITY_TYPES };
};

export const setPhysicalActivityTypes = (physicalActivityTypesList: any[]) => {
    return {
        type: SET_PHYSICAL_ACTIVITY_TYPES,
        payload: { physicalActivityTypesList }
    };
};



export const getConsultationDurationList = () => {
    return {type: GET_CONSULTATION_DURATION_LIST};
};

export const setConsultationDurationList = (consultationDurationList: IConsultationDuration[]) => {
    return {
        type: SET_CONSULTATION_DURATION_LIST, payload: {
            consultationDurationList
        }
    };
};

export const getFacilityList = () => {
    return {type: GET_FACILITY_LIST};
}

export const setFacilityList = (facilityList: any[]) => {
    return {
        type: SET_FACILITY_LIST, payload: {
            facilityList
        }
    };
}

export const getDocumentFileTypeList = () => {
    return {type: GET_DOCUMENT_FILE_TYPES};
}

export const setDocumentFileTypeList = (documentFileTypeList: any) => {
    return {
        type: SET_DOCUMENT_FILE_TYPES, payload: {
            documentFileTypeList
        }
    }
};

export const getDocumentTypeList = () => {
    return {type: GET_DOCUMENT_LIST};
}

export const setDocumentTypeList = (documentTypeList: any) => {
    return {
        type: SET_DOCUMENT_LIST, payload: {
            documentTypeList
        }
    }
};

export const getGenderList = () => {
    return {type: GET_GENDER_LIST};
};

export const setGenderList = (genderList: IGender[]) => {
    return {
        type: SET_GENDER_LIST, payload: {
            genderList
        }
    };
};


export const getPhoneTypeList = () => {
    return {type: GET_PHONE_TYPE_LIST};
};

export const setPhoneTypeList = (phoneTypeList: IPhoneType[]) => {
    return {
        type: SET_PHONE_TYPE_LIST, payload: {
            phoneTypeList
        }
    };
};

export const getLanguageList = () => {
    return {type: GET_LANGUAGE_LIST};
};

export const setLanguageList = (languageList: ILanguage[]) => {
    return {
        type: SET_LANGUAGE_LIST, payload: {
            languageList
        }
    };
};

export const getEmploymentStatusList = () => {
    return {type: GET_EMPLOYMENT_STATUS_LIST};
};

export const setEmploymentStatusList = (employmentStatusList: IEmploymentStatus[]) => {
    return {
        type: SET_EMPLOYMENT_STATUS_LIST, payload: {
            employmentStatusList
        }
    };
};

export const getRelationShipList = () => {
    return {type: GET_RELATIONSHIP_LIST};
};

export const setRelationShipList = (relationshipList: IRelationship[]) => {
    return {
        type: SET_RELATIONSHIP_LIST, payload: {
            relationshipList
        }
    };
};

export const getMedicalHistoryOptionsList = () => {
    return {type: GET_MEDICAL_HISTORY_OPTIONS_LIST};
};

export const setMedicalHistoryOptionsList = (medicalHistoryOptionsList: IMedicalHistoryOption[]) => {
    return {
        type: SET_MEDICAL_HISTORY_OPTIONS_LIST, payload: {
            medicalHistoryOptionsList
        }
    };
};

export const getSurgicalHistoryOptionsList = () => {
    return {type: GET_SURGICAL_HISTORY_OPTIONS_LIST};
};

export const setSurgicalHistoryOptionsList = (surgicalHistoryOptionsList: ISurgicalHistoryOption[]) => {
    return {
        type: SET_SURGICAL_HISTORY_OPTIONS_LIST, payload: {
            surgicalHistoryOptionsList
        }
    };
};

export const getMusculoskeletalHistoryOptionsList = () => {
    return {type: GET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST};
};

export const setMusculoskeletalHistoryOptionsList = (musculoskeletalHistoryOptionsList: IMusculoskeletalHistoryOption[]) => {
    return {
        type: SET_MUSCULOSKELETAL_HISTORY_OPTIONS_LIST, payload: {
            musculoskeletalHistoryOptionsList
        }
    };
};

export const getReferralTypeList = () => {
    return {type: GET_REFERRAL_TYPE_LIST};
};

export const setReferralTypeList = (referralTypeList: IReferralType[]) => {
    return {
        type: SET_REFERRAL_TYPE_LIST, payload: {
            referralTypeList
        }
    };
};

export const getSocialMediaPlatformList = () => {
    return {type: GET_SOCIAL_MEDIA_PLATFORM_LIST};
};

export const setSocialMediaPlatformList = (socialMediaPlatformList: ISocialMediaPlatform[]) => {
    return {
        type: SET_SOCIAL_MEDIA_PLATFORM_LIST, payload: {
            socialMediaPlatformList
        }
    };
};

export const getCommunicationModeTypeList = () => {
    return {type: GET_COMMUNICATION_MODE_TYPE_LIST};
};

export const setCommunicationModeTypeList = (communicationModeTypeList: ICommunicationModeType[]) => {
    return {
        type: SET_COMMUNICATION_MODE_TYPE_LIST, payload: {
            communicationModeTypeList
        }
    };
};


export const getBodyPartsList = () => {
    return {type: GET_BODY_PART_LIST};
};

export const setBodyPartsList = (bodyPartList: IBodyPart[]) => {
    return {
        type: SET_BODY_PART_LIST, payload: {
            bodyPartList
        }
    };
};

export const getInjuryTypeList = () => {
    return {type: GET_INJURY_TYPE_LIST};
};

export const setInjuryTypeList = (injuryTypeList: IInjuryType[]) => {
    return {
        type: SET_INJURY_TYPE_LIST, payload: {
            injuryTypeList
        }
    };
};

export const getCaseStatusList = () => {
    return {type: GET_CASE_STATUS_LIST}
}

export const setCaseStatusList = (caseStatusList: ICaseStatus[]) => {
    return {
        type: SET_CASE_STATUS_LIST, payload: {
            caseStatusList
        }
    }
}

export const getProgressReportStatsList = () => {
    return {type: GET_PROGRESS_REPORT_STATS_LIST}
}

export const setProgressReportStatsList = (progressReportStatList: IProgressReportStat[]) => {
    return {
        type: SET_PROGRESS_REPORT_STATS_LIST, payload: {
            progressReportStatList
        }
    }
}

export const get8MinuteRuleChart = () => {
    return {type: GET_8_MINUTE_RULE_CHART}
}

export const set8MinuteRuleChart = (eightMinuteRuleChart: I8MinuteRuleChartItem[]) => {
    return {
        type: SET_8_MINUTE_RULE_CHART, payload: {
            eightMinuteRuleChart
        }
    }
}

export const getConcussionFileTypes = () => {
    return {type: GET_CONCUSSION_FILE_TYPES}
}

export const setConcussionFileTypes = (concussionFileTypes: IConcussionFileType[]) => {
    return {
        type: SET_CONCUSSION_FILE_TYPES, payload: {
            concussionFileTypes
        }
    }
}

export const getMedicalRecordDocumentTypes = () => {
    return {type: GET_MEDICAL_RECORD_DOCUMENT_TYPES}
}

export const setMedicalRecordDocumentTypes = (medicalRecordDocumentTypes: IMedicalRecordDocumentType[]) => {
    return {
        type: SET_MEDICAL_RECORD_DOCUMENT_TYPES, payload: {
            medicalRecordDocumentTypes
        }
    }
}

export const getAppointmentStatusList = () => {
    return {type: GET_APPOINTMENT_STATUS_LIST};
};

export const setAppointmentStatusList = (appointmentStatusList: any[]) => {
    return {
        type: SET_APPOINTMENT_STATUS_LIST, payload: {
            appointmentStatusList
        }
    };
};

export const getPaymentModes = () => {
    return {type: GET_PAYMENT_MODES};
};

export const setPaymentModes = (paymentModes: any[]) => {
    return {
        type: SET_PAYMENT_MODES, payload: {
            paymentModes
        }
    };
};

export const getAccessibleAccounts = () => {
    return {type: GET_ACCESSIBLE_ACCOUNTS};
}

export const setAccessibleAccounts = (accessibleAccounts: any[]) => {
    return {
        type: SET_ACCESSIBLE_ACCOUNTS, payload: {
            accessibleAccounts
        }
    };
}



